import { ACTIVE, INACTIVE, NEEDS_REVIEW } from 'AccountsApp/ts/constants/integrations.constants';
import { BroadridgeIntegrationService } from 'IntegrationsApp/ts/services/broadridge-integration-service';
import { BroadridgeIntegrationActivateModalComponent } from '../broadridge-integration-activate-modal/broadridge-integration-activate-modal.component';
import { ConfirmModalComponent } from 'Angular/features/components/modals/confirm-modal/confirm-modal.component';
import * as i0 from "@angular/core";
import * as i1 from "IntegrationsApp/ts/services/broadridge-integration-service";
import * as i2 from "../../../../../../../../../../../ycharts/static/ts/features/components/modals/confirm-modal/confirm-modal.component";
import * as i3 from "Angular/features/directives/image/image.directive";
import * as i4 from "../integration-status-indicator/integration-status-indicator.component";
import * as i5 from "../broadridge-integration-activate-modal/broadridge-integration-activate-modal.component";
const _c0 = ["broadridgeDeactivateModalComponent"];
const _c1 = ["ycn-broadridge-integration-list-item", ""];
export class BroadridgeIntegrationListItemComponent {
    constructor(broadridgeIntegrationService) {
        this.broadridgeIntegrationService = broadridgeIntegrationService;
        this.status = '';
        this.errorMessage = '';
    }
    ngOnInit() {
        this.updateStatus(true);
    }
    updateStatus(confirmed) {
        if (confirmed) {
            this.broadridgeIntegrationService.getBroadridgeIntegrationStatus().subscribe({
                next: (data) => {
                    if (data.isActive) {
                        this.status = ACTIVE;
                    }
                    else if (!data.isActive && data.errorMessage === null) {
                        this.status = INACTIVE;
                    }
                    else if (!data.isActive && data.errorMessage !== null) {
                        this.status = NEEDS_REVIEW;
                        this.errorMessage = data.errorMessage;
                    }
                },
                error: () => { },
            });
        }
        else {
            this.status = INACTIVE;
        }
    }
    deactivateHandler(confirmed) {
        if (confirmed) {
            this.broadridgeIntegrationService
                .deactivateBroadridgeIntegration()
                .subscribe((res) => {
                if (res.status === 200) {
                    this.updateStatus(false);
                }
            });
        }
    }
    activateToggle() {
        if (this.status === ACTIVE) {
            this.broadridgeDeactivateModalComponent.openModal();
        }
        else {
            this.status = ACTIVE;
            this.broadridgeActivateModalComponent.openModal();
        }
    }
}
BroadridgeIntegrationListItemComponent.ɵfac = function BroadridgeIntegrationListItemComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || BroadridgeIntegrationListItemComponent)(i0.ɵɵdirectiveInject(i1.BroadridgeIntegrationService)); };
BroadridgeIntegrationListItemComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: BroadridgeIntegrationListItemComponent, selectors: [["tr", "ycn-broadridge-integration-list-item", ""]], viewQuery: function BroadridgeIntegrationListItemComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
        i0.ɵɵviewQuery(BroadridgeIntegrationActivateModalComponent, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.broadridgeDeactivateModalComponent = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.broadridgeActivateModalComponent = _t.first);
    } }, standalone: false, attrs: _c1, decls: 16, vars: 7, consts: [["broadridgeDeactivateModalComponent", ""], [1, "table-logo"], ["ycnImage", "", 2, "height", "auto", 3, "imageSrc"], [1, "text-bold"], [3, "errorMessage", "status"], [1, "text-right"], [1, "custom-control", "custom-switch"], ["type", "checkbox", 1, "custom-control-input", 3, "change", "checked"], [1, "custom-control-indicator"], [3, "updateStatusHandler"], [3, "confirmHandler", "confirmButtonText", "confirmHeader", "confirmText"]], template: function BroadridgeIntegrationListItemComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "td")(1, "div", 1);
        i0.ɵɵelement(2, "img", 2);
        i0.ɵɵelementStart(3, "div", 3);
        i0.ɵɵtext(4, "Broadridge");
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(5, "td");
        i0.ɵɵtext(6, "Portfolio Holdings");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "td");
        i0.ɵɵelement(8, "ycn-integration-status-indicator", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(9, "td", 5)(10, "label", 6)(11, "input", 7);
        i0.ɵɵlistener("change", function BroadridgeIntegrationListItemComponent_Template_input_change_11_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.activateToggle()); });
        i0.ɵɵelementEnd();
        i0.ɵɵelement(12, "span", 8);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(13, "ycn-broadridge-integration-activate-modal", 9);
        i0.ɵɵlistener("updateStatusHandler", function BroadridgeIntegrationListItemComponent_Template_ycn_broadridge_integration_activate_modal_updateStatusHandler_13_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.updateStatus($event)); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(14, "ycn-confirm-modal", 10, 0);
        i0.ɵɵlistener("confirmHandler", function BroadridgeIntegrationListItemComponent_Template_ycn_confirm_modal_confirmHandler_14_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.deactivateHandler($event)); });
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("imageSrc", "integrations/images/broadridge-logo.png");
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("errorMessage", ctx.errorMessage)("status", ctx.status);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("checked", ctx.status === "active");
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("confirmButtonText", "Deactivate")("confirmHeader", "Deactivate Broadridge Integration")("confirmText", "Are you sure you would like to deactivate your integration with Broadridge? You will not be able to use this integration unless you reactivate it.");
    } }, dependencies: [i2.ConfirmModalComponent, i3.ImageDirective, i4.IntegrationStatusIndicatorComponent, i5.BroadridgeIntegrationActivateModalComponent], encapsulation: 2 });
